import check from '../../assets/check.svg';
import view from '../../assets/view.svg';
import { Member } from '../../models';
import { useActivityData } from './UseActivityData';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { MemberProfileModal } from './MemberProfileModal';

function MemberRow({ member }: { member: Member }) {
  const { room } = useActivityData();
  const { activity } = room || {};
  const neverStart = (!activity?.startAt && !activity?.endAt) || false;
  const { id, name, dailyStatus, finishedTaskCount } = member;
  const [isMemberModalOpen, setMemberModalOpen] = useState(false);
  const [userChatHistoryUrl, setUserChatHistoryUrl] = useState<string>();

  const onMemberProfileModalOpen = () => {
    setMemberModalOpen(true);
  };

  const onMemberProfileModalClose = () => {
    setMemberModalOpen(false);
  };

  useEffect(() => {
    if (!room) {
      return;
    }
    const { roomUrl } = room;
    const url = `${roomUrl}&userId=${id}`;
    setUserChatHistoryUrl(url);
  }, [room, id]);

  return (
    <>
      <tr>
        <td
          className="relative py-3 cursor-pointer"
          align="center"
          onClick={onMemberProfileModalOpen}
        >
          {name}
          <div className="absolute top-0 right-0 flex flex-col h-full justify-center">
            <div className="h-4 border-r"></div>
          </div>
        </td>
        <td className="relative" align="center">
          {dailyStatus.finished ? <img alt="checked" src={check} /> : <></>}
          <div className="absolute top-0 right-0 flex flex-col h-full justify-center">
            <div className="h-4 border-r"></div>
          </div>
        </td>
        <td className="relative" align="center">
          {dailyStatus.hasFeedback ? <img alt="checked" src={check} /> : <></>}
          <div className="absolute top-0 right-0 flex flex-col h-full justify-center">
            <div className="h-4 border-r"></div>
          </div>
        </td>
        <td className="relative" align="center">
          <Link to={`members/${id}`} className="container text-group-primary">
            {finishedTaskCount}
          </Link>
          {!neverStart && (
            <div className="absolute top-0 right-0 flex flex-col h-full justify-center">
              <div className="h-4 border-r"></div>
            </div>
          )}
        </td>
        {!neverStart && (
          <td>
            <a
              className="flex flex-grow justify-center cursor-pointer"
              href={userChatHistoryUrl}
            >
              <img alt="view" src={view} />
            </a>
          </td>
        )}
      </tr>
      <MemberProfileModal
        isOpen={isMemberModalOpen}
        member={member}
        onMemberProfileModalClose={onMemberProfileModalClose}
      />
    </>
  );
}

export default function MemberTable({ members }: { members: Member[] }) {
  const [t] = useTranslation(['chatroom']);
  const { room } = useActivityData();
  const { activity } = room || {};
  const neverStart = (!activity?.startAt && !activity?.endAt) || false;
  return (
    <div className="flex-grow overflow-y-scroll">
      <table className="mt-5 table-fixed w-full">
        <thead className="sticky top-0 bg-gradient-to-b from-[#79BF99] to-[#53A077] z-50">
          <tr className="font-medium text-white text-sm h-14">
            <th className="rounded-tl-lg w-5/12">
              {t('manage_member_table_column_name', '組員')}
            </th>
            <th className="px-2">
              {t('manage_member_table_column_task', '本日任務')}
            </th>
            <th className="px-2">
              {t('manage_member_table_column_feedback', '本日回饋')}
            </th>
            <th className={neverStart ? 'px-2 rounded-tr-lg' : 'px-2'}>
              {t('manage_member_table_column_count', '完成累計')}
            </th>
            {!neverStart && (
              <th className="rounded-tr-lg">
                {t('manage_member_table_column_look', '查看')}
              </th>
            )}
          </tr>
        </thead>
        <tbody className="bg-white">
          {members.map((member) => (
            <MemberRow key={member.id} member={member} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
